import axios from "axios";
import { BACKEND_BASE, BACKEND_DOMAIN } from "./baseUrl";

export const APIBaseUrl = axios.create({
    baseURL: `${BACKEND_DOMAIN}${BACKEND_BASE}`,
});
APIBaseUrl.interceptors.request.use(
    config => {
        try {
            let token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiU1NTIEFkbWluIiwicGhvbmUiOiI5ODg0NTI1ODAyIiwiYXZhdGFyIjoiIiwiX2lkIjoiNjhmOGI0NTUzZTcwYmJhMGE5ODY1MDY5IiwiZW1haWxfaWQiOiJjb25uZWN0QHN1Y2Nlc3NzaGlwcGluZy5pbiIsInJvbGVfaWQiOiI2OGY4YjA0NjRiOTVlNDFlZjY5NTQzZjgiLCJ0ZW5hbnRfaWQiOiI2OGY4YWRkMDRiOTVlNDFlZjY5NTM4MDkiLCJzZWNvbmRhcnlfcm9sZV9pZCI6W10sInBob3RvVVJMIjpudWxsLCJpYXQiOjE3NjE3MTM0NTd9.bzDjmknfDNVE_geFcPjzvEFqcrkCpOvMD_cqNjNz9Qk';
            config.headers['Authorization'] = `Bearer ${token}`;
        } catch (e) {
            // console.log(e.message);
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
)